import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalaryAdvanceComponent } from './salary-advance.component';

const routes: Routes = [
    {
        path: '',
        component: SalaryAdvanceComponent,
      },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SalaryAdvanceRoutingModule {}
